const FeesIcon = () => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M4 10.4615H20M15.0769 14.7692H16.9231M18.7692 6.15381H5.23077C4.55103 6.15381 4 6.70485 4 7.38458V16.6153C4 17.2951 4.55103 17.8461 5.23077 17.8461H18.7692C19.449 17.8461 20 17.2951 20 16.6153V7.38458C20 6.70485 19.449 6.15381 18.7692 6.15381Z" stroke="#CEFF1A" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    )
}

export default FeesIcon;